export const ACCOUNT_CLIENT_EDIT_FIELDS = [
  "pan",
  "gstin",
  "contactPerson",
  "mobile",
  "email",
  "address1",
  "address2",
  "city",
  "state",
  "pinCode",
  "additionalContacts",
];

export function getClientMasterRole(userData) {
  if (userData?.profileType !== "staff" || userData?.active !== true) return "";
  return String(userData.role || "").toLowerCase();
}

export function hasFullClientAccess(userData) {
  return ["admin", "partner"].includes(getClientMasterRole(userData));
}

export function hasLimitedClientEditAccess(userData) {
  return getClientMasterRole(userData) === "accounts";
}
